import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'

export class NoteApiService extends ApiService {
  static async submitNote(noteId: string, data: object): Promise<IServiceResponse<object>> {
    return this.axios.put(`notes/${noteId}`, data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async deleteNote(noteId: string): Promise<IServiceResponse<object>> {
    return this.axios.delete(`notes/${noteId}`)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }
}
